import { MouseEvent, useEffect, useState } from 'react'
import { Typography, Card, Box, Stack, Button } from '@mui/material'
import {
  CardItem,
  TypCity,
  TypDescription,
} from './style'
import { formatNumber } from '../../../../common/FormatNumber'
import { ViewCounter } from '../../../ui-kit/ViewCounter'
import { useNavigate } from 'react-router-dom'
import { routesProfile } from '../../../../consts'
import type { TeamDescription } from '../../../../types/entitys/teams'
import { profileApi } from '../../../../api/profile'
import { TeamSubscribeButton } from '../../TeamSubscribeButton'
import { UserAvatar } from '../../../common/UserAvatar'

type TeamProps = {
  team: TeamDescription
}

export const DesktopCard = ({ team }: TeamProps) => {
  const navigate = useNavigate()
  const { data: me } = profileApi.useGetProfileQuery()
  const isAuthor = me?.id !== undefined && me.id === team.authorId
  const [subscribersCount, setSubscribersCount] = useState(Number(team.subscribers ?? 0))

  useEffect(() => {
    setSubscribersCount(Number(team.subscribers ?? 0))
  }, [team.id, team.subscribers])
  const handleEdit = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    navigate(`/${routesProfile.TEAMS.path}/${team.id}/edit`)
  }
  const navigateToTeam = () => {
    navigate(`/${routesProfile.TEAMS.path}/${team.slug || team.id}`)
  }
  const handleStopPropagation = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
  }

  return (
    <Card variant="primaryCard" sx={CardItem} onClick={navigateToTeam}>
      <Stack direction="row" gap={3}>
        <Box>
          <UserAvatar src={team.image} size={100} />
        </Box>
        <Stack direction="column" gap={1} minWidth={0} width="100%">
          <Stack direction="column">
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h3" flex={1} minWidth={0} noWrap>
                {team.title}
              </Typography>
              {isAuthor ? (
                <Button variant="follow" sx={{ ml: 1 }} onClick={handleEdit}>
                  Редактировать
                </Button>
              ) : (
                <TeamSubscribeButton
                  teamId={team.id}
                  isSubscribed={team.isSubscribed}
                  onClick={handleStopPropagation}
                  onSubscriptionChange={(wasSubscribed) => {
                    setSubscribersCount((n) => Math.max(0, n + (wasSubscribed ? -1 : 1)))
                  }}
                />
              )}
            </Stack>
            <Typography variant="h4" sx={TypCity} noWrap>
              {team.city}
            </Typography>
          </Stack>
          <Typography variant="body1" sx={TypDescription}>
            {team.descriptionFull}
          </Typography>
          <Stack direction="row" gap={1.5} alignItems="center">
            <Typography variant="h4">Участников: {formatNumber(team.participants)}</Typography>
            <Typography flex={1} variant="h4">
              Подписчиков: {formatNumber(subscribersCount)}
            </Typography>
            <ViewCounter count={team.views} />
          </Stack>
        </Stack>
      </Stack>
    </Card>
  )
}
